export const getContainer = () => {
	return {
		center: true,
		padding: {
			DEFAULT: "1.6rem",
			sm: "1rem",
			lg: "1rem",
		}
	}
};
